import React from 'react'
import nanoid from 'nanoid'
import { Wrapper, Label, Input, Textarea, HelpText } from './styles'

export default ({
  label,
  placeholder,
  onChange,
  value,
  maxLength,
  type = 'text',
  id = nanoid(),
  border = false,
  help = false,
  ...inputProps
}) => (
  <Wrapper border={border}>
    {label && (
      <Label tag={'label'} htmlFor={id}>
        {label}
      </Label>
    )}
    {type === 'textarea' ? (
      <>
        <Textarea
          {...inputProps}
          id={id}
          placeholder={placeholder}
          value={value}
          maxLength={maxLength}
          onChange={({ target: { value } }) => {
            onChange(value)
          }}
          help={help}
        />
        {help && <HelpText>Du kan bruge emojis 😉</HelpText>}
      </>
    ) : (
      <Input
        {...inputProps}
        type={type}
        id={id}
        placeholder={placeholder}
        value={value}
        onChange={({ target: { value } }) => {
          onChange(value)
        }}
      />
    )}
  </Wrapper>
)
